import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import util from "../../utils/miniUtils";
import { showApiError } from "./salesHelpers";

// RESOLUTION_NOTE_MAX_LENGTH de inventory-api
const NOTE_MAX_LENGTH = 1000;

const validationSchema = Yup.object().shape( {
    note: Yup.string()
        .trim()
        .required( "La nota es obligatoria para atender la alerta" )
        .max( NOTE_MAX_LENGTH, `Máximo ${NOTE_MAX_LENGTH} caracteres` ),
} );

// Atender una alerta abierta con nota obligatoria. Solo Admin (la API responde 403 a los demás).
export default function ResolveAlertForm( { alert, onSaved } ) {
    const formik = useFormik( {
        initialValues: { note: "" },
        validationSchema,
        onSubmit: resolveAlert,
    } );

    async function resolveAlert( values ) {
        try {
            const request = await util.axios.post( `sales/alerts/${alert.id}/resolve`, { note: values.note.trim() } );
            const { error, msg } = request.data;
            if ( error ) throw msg;
            util.toast().success( msg );
            onSaved();
        } catch ( e ) {
            showApiError( e );
        }
    }

    const noteError = ( formik.touched.note || formik.submitCount > 0 ) && formik.errors.note;

    return (
        <form onSubmit={formik.handleSubmit} className="mt-2" data-cy={`sales-alert-form-${alert.id}`}>
            <label htmlFor={`sales-alert-note-${alert.id}`} className="form-label small">Nota de lo que se hizo</label>
            <textarea
                id={`sales-alert-note-${alert.id}`}
                name="note"
                rows={2}
                className="form-control form-control-sm"
                value={formik.values.note}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                data-cy={`sales-alert-note-${alert.id}`}
            />
            {noteError && <div className="text-danger small">{formik.errors.note}</div>}
            <button type="submit" className="btn btn-sm btn-warning mt-2" disabled={formik.isSubmitting} data-cy={`sales-alert-resolve-${alert.id}`}>
                Marcar como atendida
            </button>
        </form>
    );
}
